module.exports = __webpack_public_path__ + "img/folder.2723f228.svg";